import { UiActionEvent } from '../../ui/events/ui-action'
import { parameters } from '../parameters/search-result-click'

/**
 * ET-1 "Result clicked": a `ui_action` event emitted when a subscriber selects
 * a search result (CR-409 FR-3.2).
 *
 * Every parameter that varies per card — the section, the position, the result
 * count and the content identity — is passed at construction time; only the
 * card-shape constants come from {@link parameters}.
 */
export class SearchResultUiActionEvent extends UiActionEvent {
  parameters = parameters
}
